import React, { Component } from 'react';
import { Pagination, Spin, Button, Modal, Tooltip, Select, Input } from 'antd';
import { UndoOutlined, CloseOutlined, SendOutlined, FileDoneOutlined, HistoryOutlined, DownloadOutlined, FileAddFilled, ProfileOutlined, AlignLeftOutlined } from '@ant-design/icons';
import { patientPendingSchema } from '../../schema/bill-tacking';
import { preauthSchema, preauthFileSchema } from '../../schema/preauthform';
import Select2 from '../../components/FormComponent/select2';
import Select2multiple from '../../components/FormComponent/select2/multiple';
import moment from 'moment';
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';
import Counselling_upload from '../Counselling/newCounsellingForms/uploadDocument';
import Storage from '../../services/local-store';
import userTrackService from '../../services/usertrack-service';
import Tableantd from '../../components/version2form_component/table/antd';
import DateRange from '../../components/FormComponent/DateRange';
import { CSVLink } from "react-csv";
import New_Counselling_upload from '../Counselling/newCounsellingForms/newFileUploadDocuments';
import { tableHead,thead } from './tableData';
import { mapAssignedFrom, mapAssignedTo } from '../Insurance_Executive_Worklist/tableData';
import html2PDF from 'jspdf-html2canvas';
import ReactToPrint from "react-to-print";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { UPLOAD_URL } from '../../../src/constants/app-constants';

var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]


const {homepage} = networkList;
let i = 0;
class PostAuthWorklist_completed extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.componentRef = React.createRef();
        this.state = {
            'loadding': false,
            'page_data_count': 1,
            'search_key': '',
            previlege_data: [],
            responseData: [],
            tableHead: [],
            page_length: 20,
            'total_items': 0,
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            'downloadtbody': [],
            downloadStatus: 0,
            tbody: [],
            "doctor_id": [],
            "department_name": [],
            preauthSchema: JSON.parse(JSON.stringify(preauthSchema['feilds'])),
            preauthdata: [],
            viewpdf: false,
            ViewURLPDF: '',
            patientHistory: [],
            thead: [],
            checked: true,
            preauthFileSchema: preauthFileSchema['feilds'],
            pre_auth_submits:'',
            insurance_status:'',
            fc_payer_type:'',
            hims_payer_type:'',
            modalVisible: true,
            nme_clearance_form: false,
            fetching: false,
            select_options: [],
            selectTouched: false,
            dropdownVisible: false,
            selectedOptions: [],
            coPayAmount: 0,
            differenceAmount: 0,
            discountAmount: 0,
            totalBillAmount: 0,
            insuranceApproveAmount: 0,
            payableAmount: 0,
            netPayableAmount: 0,
            lessAdvance: 0,
            finalAmount: 0,
            insuranceCleranceRemarks: '',
            patient_details: {},
            responseLength: false,
            preview_insurance_clearance: false,
            currentDate: new Date(),
            showInput: true
        }
    }

    componentDidMount() {
        try {
            let tableHead = [{
                'key': 'ip_no',
                'text': 'IP number'
            }, {
                'key': 'umr_no',
                'text': 'UMR number'
            }, {
                'key': 'patient_name',
                'text': 'Patient Name'
            }, {
                'key': 'phone_number',
                'text': 'Phone Number'
            }, {
                'key': 'date_of_counselling',
                'text': 'date of counselling'
            }, {
                'key': 'doctor_name',
                'text': 'Doctor Name'
            }, {
                'key': 'department_name',
                'text': 'Department Name'
            }, {
                'key': 'unit_name',
                'text': 'Unit Name'
            },
            {
                'key': 'rn_preauth_submitted',
                'text': 'Pre-auth Submitted'
            },
            {
                'key': 'payer_reponse_remarks',
                'text': 'Insurance Status'
            },
            {
                'key': 'fc_payer_type',
                'text': 'FC Payer Type'
            },
            {
                'key': 'hims_payer_type',
                'text': 'HIMS Payer Type'
            },
            {
                'key': 'rn_preauth_requested_time',
                // 'text': 'Preauth Submission Date'
                'text': 'Pre-Auth Triggered Time'
            },
            {
                'key': 'rn_preauth_submitted_date',
                'text': 'Pre-Auth Requested Time'
            }, {
                'key': 'payer_updated_at',
                'text': 'Preauth Response Received Date'
            },
            {
                'key': 'payer_approved_amount',
                'text': 'Approved Amount(Rs.)'
            },
            {
                'key': 'remedinet_remarks',
                'text': 'Remedinet Remarks'
            },
            {
                'key': 'approval_file_name',
                'text': 'Document received from Remedinet'
            },
            {
                'key': 'is_lan_bill_prepared',
                'text': 'Lan Bill Prepared'
            },
            {
                'key': 'corp_approx_final_bill_status',
                'text': 'Crop Approx Final Bill Status'
            },
            {
                'key': 'discharge_summary_approval_status',
                'text': 'Discharge Summary Approval Status'
            },
            {
                'key': 'action',
                'text': 'Action'
            },
            {
                'key': 'insurance',
                'text': 'NME Clearance'
            }
    
            ];
        let formSchema = Object.assign({}, patientPendingSchema);
        formSchema['feilds'].map((feild, key) => {
            if (feild.name === 'doctorid') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Doctor';
            } else if (feild.name === 'pendingDocs_departmentbyunit') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Department';
            } else if (feild.name === 'pre_auth_submitted') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Pre-Auth Submitted';
            }
            else if (feild.name === 'insurance_status') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Insurance Status';
            }
            else {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                delete formSchema['feilds'][key]['text'];
            }


        })
        this.setState({ activePage: 1, totalItemsCount: 0, 'formData': formSchema['feilds'], 'tableHead': tableHead, search_key: '' }, () => {
            this.renderBody();
        });
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }
    }

    componentWillUnmount() {
        // clearInterval(this.interval);
    }

    renderBody() {
        const data = this.props;
        i = 0;
        let { getPostauthWorklist } = networkList;
        let { page_data_count, search_key, doctor_id, department_name ,pre_auth_submits,insurance_status,fc_payer_type,hims_payer_type} = this.state;
        this.setState((state) => ({ loadding: true, download_btn: true, downloadStatus: 0 }));
        let This = this;
        try {
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            postService('getPostauthWorklist', 'POST', {
                'data': {
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    'page_no': page_data_count,
                    'page_number': page_data_count,
                    'page_data_count': page_data_count,
                    "search_key": search_key,
                    "doctor_id": doctor_id ? doctor_id : [],
                    "department_name": department_name ? department_name : [],
                    "preauth_submitted":pre_auth_submits?pre_auth_submits:[],
                    "insurance_status":insurance_status?insurance_status:[],
                    "fc_payertype":fc_payer_type?fc_payer_type:[],
                    "rn_payer_response":"completed",
                    "hims_payertype":hims_payer_type?hims_payer_type:[],
                    "from": This.state.dateFrom ? moment(this.state.dateFrom).format('YYYY-MM-DD') : '',
                    "to": This.state.dateTo ? moment(this.state.dateTo).format('YYYY-MM-DD') : '',
                    "export": 0, //1 for download excel
                }
            }).then(res => {
                this.setState((state) => ({ loadding: false }));
                if (res.status) {
                    if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                        this.setState((state) => ({ 'tbody': res['data'], 'total_items': res['total_count'], loadding: false }))
                    } else {
                        this.setState((state) => ({ 'tbody': [], 'total_items': 0 }))

                    }
                } else {
                    if (res === 401) {

                    } else {
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again.",
                        });
                    }

                }
            })


        } catch (error) {
            this.setState((state) => ({ loadding: false }));
        }
    }

    navigateTo(body) {
        try {
        let { umr, unit_id } = body
        this.props.history.push(`/patients-history?umr=${umr}&unit_id=${unit_id}`);
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }

    }

    pageChange(data) {
        this.setState((state) => ({ 'page_data_count': data }), () => {
            this.renderBody();
        })
    }

    searchClick() {
        try {
            let { getPostauthWorklist } = networkList;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
        let { page_data_count, search_key, doctor_id, department_name ,pre_auth_submits,insurance_status,fc_payer_type,hims_payer_type} = this.state;
            postService('getPostauthWorklist', 'POST', {
                'data': {
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    'page_no': 1,
                    'page_number': 1,
                    'page_data_count': 1,
                    "search_key": search_key,
                    "doctor_id": doctor_id ? doctor_id : [],
                    "department_name": department_name ? department_name : [],
                    "preauth_submitted":pre_auth_submits?pre_auth_submits:[],
                    "insurance_status":insurance_status?insurance_status:[],
                    "fc_payertype":fc_payer_type?fc_payer_type:[],
                    "rn_payer_response":"completed",
                    "hims_payertype":hims_payer_type?hims_payer_type:[],
                    "from": '',
                    "to": '',
                    "export": 0, //1 for download excel
                }
            }).then(res => {
                this.setState((state) => ({ loadding: false }));
                if (res.status) {
                    if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                        this.setState((state) => ({ 'tbody': res['data'], 'total_items': res['total_count'], loadding: false }))
                    } else {
                        this.setState((state) => ({ 'tbody': [], 'total_items': 0 }))

                    }
                } else {
                    if (res === 401) {

                    } else {
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again.",
                        });
                    }

                }
            })


        this.setState((state) => ({
            activePage: 1,
            tbody: [],
            totalItemsCount: 0,
            doctor_id: [],
            department_name: []
        }), () => {
            var formFeilds = this.state.formData;
            formFeilds.map((feild, key) => {
                if (feild.name === 'doctorid') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Doctor';
                } else if (feild.name === 'pendingDocs_departmentbyunit') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Department';
                }
                else if (feild.name === 'pre_auth_submitted') {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Pre-Auth Submitted';
                }
                else if (feild.name === 'insurance_status') {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Insurance Status';
                } else {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    delete formFeilds[key]['text'];
                }
            })
            this.setState({ formData: formFeilds })
        })
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }
    }

    searchChange(e) {
        try {
        console.log(e.target.value);
        let value = e.target.value
        i = 0;
        this.setState((state) => ({
            'search_key': value
        })
        );
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }
    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    indexIncrement() {
        i = i + 1;
    }
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
            page_data_count: 1,
            search_key: ''
        }), () => {
            this.inputRef.value = null;
            this.renderBody(true);
        })
    }
    downloadFile = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, department_name, page_data_count,search_key,pre_auth_submits,insurance_status,fc_payer_type,hims_payer_type,fc_payer_status } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getPostauthWorklist } = networkList;
            This.setState((state) => ({ downloadStatus: 0, loadding: true, filename: 'Post-Auth Worklist.csv' }), () => {
                let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            if (this.state.fc_payer_status === 'All') {
                fc_payer_status = [];
            }
            postService('getPostauthWorklist', 'POST', {
                'data': {
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    'page_no': page_data_count,
                    'page_number': page_data_count,
                    'page_data_count': page_data_count,
                    "search_key": search_key,
                    "doctor_id": doctor_id ? doctor_id : [],
                    "department_name": department_name ? department_name : [],
                    "preauth_submitted":pre_auth_submits?pre_auth_submits:[],
                    "insurance_status":insurance_status?insurance_status:[],
                    "fc_payertype":fc_payer_type?fc_payer_type:[],
                    "hims_payertype":hims_payer_type?hims_payer_type:[],
                    "fc_payer_status":fc_payer_status,
                    "rn_payer_response":"completed",
                    "from": This.state.dateFrom ? moment(this.state.dateFrom).format('YYYY-MM-DD') : '',
                    "to": This.state.dateTo ? moment(this.state.dateTo).format('YYYY-MM-DD') : '',
                    "export": 1, //1 for download excel
                }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        // res.data.map((data, key) => {
                        //     Object.keys(data).map((dataKey) => {
                        //         // if (dataKey === 'admission_date') {
                        //         //     res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                        //         // }
                        //         // if (dataKey === 'latest_counselled_date') {
                        //         //     res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                        //         // }
                        //         // else {
                        //         res.data[key][dataKey] = res.data[key][dataKey] ? res.data[key][dataKey] : 'NA'
                        //         // }

                        //     })
                        // })
                        const filteredTableHead = tableHead.filter(header => header.key !== 'action');
                        let csvKeys = filteredTableHead.map((header) => header.key);
                        let csvHeaders = filteredTableHead.map((header) => header.text);
                        let csvData = [csvHeaders];
                        res.data.forEach((rowData) => {
                            let row = [];
                            csvKeys.forEach((key) => {
                                let value = rowData[key] || 'NA';
                                if (key === 'assigned_from') {
                                    value = mapAssignedFrom(value);
                                }
                                if (key === 'assigned_to') {
                                    value = mapAssignedTo(value);
                                }
                                row.push(value);
                            });
                            csvData.push(row);
                        });
                        This.setState((state) => ({ downloadtbody: csvData, loadding: false, downloadStatus: 1 }));
                        this.csvLink.current.link.click();
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }
    clearFilter = () => {
        try {
        this.setState(() => ({ doctor_id: '', department_name: '', search_key: '', activePage: 1, totalItemsCount: 0 , pre_auth_submits:'',
        insurance_status:'',
        fc_payer_type:'',
        hims_payer_type:'',
        }),
            () => {
                this.inputRef.value = null;
                var formFeilds = this.state.formData;
                formFeilds.map((feild, key) => {
                    if (feild.name === 'doctorid') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Doctor';
                    } else if (feild.name === 'pendingDocs_departmentbyunit') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Department';
                    }else if (feild.name === 'pre_auth_submitted') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Pre-Auth Submitted';
                    }
                    else if (feild.name === 'insurance_status') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Insurance Status';
                    }
                     else {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        delete formFeilds[key]['text'];
                    }
                })
                this.setState({ formData: formFeilds })
                this.renderBody();
            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })
        }

    }

    openupload = (data) => {
        try {
        let { unit_id, umr_no, ip_no, counsellng_id, patient_name, date_of_counselling } = data
        let { resData } = this.state
        let sendData = {
            'unit_id': unit_id,
            'umr_no': umr_no,
            'ip_no': ip_no,
            'patient_name': patient_name,
            'temp': Math.floor(Math.random() * 100),
            'counselling_id': counsellng_id,
            'date_of_counselling': date_of_counselling
        }
        this.setState(() => ({ 'mydata': sendData }), () => { this.child.setModal1Visible(true) });
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })

    }

    }
    
    submit() {
        try {
        var formFeilds = this.state.formData;
        let { search } = this.state
        this.setState(({ doctor_id: formFeilds[1].value, department_name: formFeilds[2].value, search_key: '', activePage: 1, pre_auth_submits:formFeilds[3].value,
        insurance_status:formFeilds[4].value,
        fc_payer_type:formFeilds[5].value,
        hims_payer_type:formFeilds[6].value
        }), () => {
            this.inputRef.value = null;
            this.renderBody()
        })
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })

    }
    }
    modelVisisablePostAuthSubmit(data) {
        let { preauthFileSchema } = this.state;

        let { getUploadPatientsDocumentsDetails,getPatientDocumentDetails, getRemedinetPayerlist, getRemedinetZoneslist, getRemedinetInsurancesCompanyList } = networkList;
        let payload = {
            counselling_id: data.counsellng_id,
            form_type: "view",
            ip_no: data.ip_no,
            umr_no: data.umr_no,
            unit_id: data.unit_id
        }

        const patient_name = data.patient_name;
        const umr_no = data.umr_no;
        const ip_no = data.ip_no
        let payerText, zoneText, insurance_company_text;
        
        if (data.tpacode !== null && data.tpacode !== '' && data.tpacode !== undefined) {
            postService(getRemedinetPayerlist, 'POST', {
                "data": { "unit_id": data.unit_id ? data.unit_id : '' }
            }).then(res => {
                const payer = res['data']
                if (payer) {
                    payerText = payer.find(x => x.id === data.tpacode)
                }
            });

        }
        if (data.zone_id !== null && data.zone_id !== '' && data.zone_id !== undefined) {
            postService(getRemedinetZoneslist, 'POST', {
                "data": { "unit_id": data.unit_id ? data.unit_id : '', "payercode": data.tpacode ? data.tpacode : '' }
            }).then(res => {
                const zone = res['data']
                if (zone) {
                    zoneText = zone.find(x => x.id === data.zone_id);
                }
            });
        }
        if (data.insurance_company_id !== null && data.insurance_company_id !== '' && data.insurance_company_id !== undefined) {
            postService(getRemedinetInsurancesCompanyList, 'POST', {
                "data": { "unit_id": data.unit_id ? data.unit_id : '', "payercode": data.tpacode ? data.tpacode : '' }
            }).then(res => {
                const insurance_company = res['data']
                if (insurance_company) {
                    insurance_company_text = insurance_company.find(x => x.id === data.insurance_company_id)
                }
            });
        }
        let preAuthFile = [
            {
                'key': 's_no',
                'text': '#'
            },
            {
                'key': 'document_url',
                'text': 'Document  Name',
            }
        ];
        preauthFileSchema.map((subTable, key) => {
            let table_body = subTable.Specification.table_body;
            table_body.map((feild, table_key) => {
                if (table_body.length > 0) {
                    preauthFileSchema[key].Specification.table_body.splice(1, table_body.length-1)
                }
            })
        })
        console.log(preauthFileSchema)
        try {
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get Patient Document Details - Request",
                    "date": new Date(),
                    "meta": payload
                }
            }
            userTrackService(Userlogobj);
            postService(getUploadPatientsDocumentsDetails, 'POST', { "data": payload }).then(res => {
                const Userlogobjres = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "get Patient Document Details - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res['status']) {
                    let latest_cou_id = res['latest_counselling_id'] ? res['latest_counselling_id'] : null
                    this.setState((state) => ({ 'patientDocument': res['data'], 'latest_counselling_id': latest_cou_id, preAuthFile: preAuthFile, patient_name: data.patient_name, umr_no: data.umr_no, ip_no: data.ip_no }));
                    this.setState({ loadding: false })
                    if (res['data'].length > 0) {
                        if (res['data'].some(item => item.is_uploaded === '1')) {
                            let { preauthSchema } = this.state;
                            preauthSchema.map((item) => {
                                if (item.name === "payer") {
                                    if (data.tpacode !== null && data.tpacode !== '' && data.tpacode !== undefined) {
                                        item.text = payerText ? payerText.name : null;
                                        item.value = data.tpacode ? data.tpacode : null;
                                    } else {
                                        item.text = 'Select Payer';
                                        item.value = null;
                                        item.errors =[];
                                    }
                                }
                                if (item.name === 'zone') {
                                    if (data.zone_id !== null && data.zone_id !== '' && data.zone_id !== undefined) {
                                        item.text = zoneText ? zoneText.name : '';
                                        item.value = data.zone_id ? data.zone_id : '';
                                        item.disable = data.zone_id ? false : true;
                                    } else {
                                        item.text = 'Select Zone';
                                        item.value = null;
                                        item.disable = true;
                                    }
                                }
                                if (item.name === 'insurance_company_name') {
                                    if (data.insurance_company_id !== null && data.insurance_company_id !== '' && data.insurance_company_id !== undefined) {
                                        item.disable = false;
                                        item.text = insurance_company_text ? insurance_company_text.name : '';
                                        item.value = data.insurance_company_id ? data.insurance_company_id : '';
                                    } else {
                                        item.disable = true;
                                        item.text = 'Select Insurance Company';
                                        item.value = null;
                                    }
                                }
                            });
                          
                            if (res['data'].length > 0) {
                                preauthFileSchema.map((subTable, key) => {
                                    let table_body = subTable.Specification.table_body;
                                    table_body.map((feild, table_key) => {
                                        if (table_body.length > 0) {
                                                preauthFileSchema[key].Specification.table_body.length=0;
                                         
                                        }
                                    })
                                })
                                preauthFileSchema.map((data, secKey) => {
                                    preauthFileSchema[secKey].visible = true;
                                    res['data'][0].document_url.map((file, file_key) => {
                                        if(file['document_url']){
                                            let last_element = preauthFileSchema[secKey].Specification.table_body[preauthFileSchema[secKey].Specification.table_body.length - 1];
                                            

                                            let obj = {
                                                "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                                id: file_key+1,
                                                input_feild: [],
                                                text: "Highend",
                                                'key_word': 'add_more',
                                                type: "text"
                                            }
                                            obj['feilds'].map((feild, key) => {
                                                obj['feilds'][key]['id'] = null;
                                                obj['feilds'][key]['value'] = null;
                                                obj['feilds'][key]['text'] = null;
                                            })
                                            obj['feilds'].map((feild, key) => {
                                                obj['feilds'][key]['id'] = file_key + 1;
                                                if (feild.name === "file_access") {
                                                    obj['feilds'][key]['value'] = file['is_uploaded'] ? true : false
                                                    obj['feilds'][key]['file_upload_id'] =file['file_uploading_id']

                                                }
                                                if (feild.name === "document_name") {
                                                    obj['feilds'][key]['value'] = file['document_url'];
                                                    obj['feilds'][key]['text'] = file['document_url'];
                                                    obj['feilds'][key]['patient_name'] = patient_name
                                                    obj['feilds'][key]['umr_no'] = umr_no
                                                    obj['feilds'][key]['ip_no'] = ip_no

                                                }

                                            })
                                            data['Specification']['table_body'].push(obj);
                                        }
                                    }
                                    // }

                                    )

                                });
                            }
                            console.log(preauthFileSchema)
                           
                            this.setState({
                                commentModal: true, preauthSchema: JSON.parse(JSON.stringify(preauthSchema)), preauthdata: data, preAuthFile: preAuthFile, preauthFileSchema: preauthFileSchema
                            });
                        } else {
                            Modal.error({
                                title: 'Error Message',
                                content: 'Please upload atleast one document before submitting the Post-auth.',
                            })
                        }
                    } else {
                        Modal.error({
                            title: 'Error Message',
                            content: 'Please upload atleast one document before submitting the Post-auth.',
                        })
                    }

                } else {
                    this.setState((state) => ({ 'patientDocument': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }


    }
    historyPreAuth(data) {
        let { getRemedinetPayerHistory } = networkList;
        if (data.rn_reference_number) {
            postService(getRemedinetPayerHistory, 'POST', {
                "data": { "unit_id": data.unit_id ? data.unit_id : '', "refNo": data.rn_reference_number ? data.rn_reference_number : '' }
            }).then(res => {
                if (res.status) {
                    this.setState({ viewHistory: true, patientHistory: res.data, thead: thead, patient_name: data.patient_name, umr_no: data.umr_no, ip_no: data.ip_no })
                }
                else {
                    this.setState({ viewHistory: true, patientHistory: res.data, thead: thead, patient_name: data.patient_name, umr_no: data.umr_no, ip_no: data.ip_no })
                }

            });
        }

    }

    handleCloseModal = () => {
        this.setState({ modalVisible: false });
    };

    updatetoGREfromExecutive (data) {
        let payload={
            "primary_id":data.fk_admission_id,
            "umr_no":data.umr_no,
            "role_id":'RL_weyI'
        }
        this.setState((state) => ({fetching: true,}), () => {
            postService('updatetoGREfromExecutive','POST',{data:payload}).then(res => {
                if (res.status) {
                    this.setState((state) => ({fetching: false,}))
                    Modal.success({
                        'title': 'Success Message',
                        'content': `${res.message}`,
                        zIndex: 2000,
                        onOk: () => {
                            this.handleCloseModal()
                        }
                    })
                }else {
                    this.setState((state) => ({fetching: false,}))
                    Modal.error({
                        'title': 'Error Message',
                        'content': `${res.message}`,
                        zIndex: 2000
                    })
                }
            })
        })
    }

    updatetoDMOfromExecutive (data) {
        let payload={
            "primary_id":data.fk_admission_id,
            "umr_no":data.umr_no,
            "role_id":'RL_8GzM'
        }
        this.setState((state) => ({fetching: true,}), () => {
            postService('updatetoGREfromExecutive','POST',{data:payload}).then(res => {
                if (res.status) {
                    this.setState((state) => ({fetching: false,}))
                    Modal.success({
                        'title': 'Success Message',
                        'content': `${res.message}`,
                        zIndex: 2000,
                        onOk: () => {
                            this.handleCloseModal()
                        }
                    })
                }else {
                    this.setState((state) => ({fetching: false,}))
                    Modal.error({
                        'title': 'Error Message',
                        'content': `${res.message}`,
                        zIndex: 2000
                    })
                }
            })
        })
    }

    modelVisisableViewpdf(ele) {
        this.setState({ viewpdf: true, ViewURLPDF: ele })

    }
    PDFModelClose() {
        this.setState({ viewpdf: false })
    }
    submitPreAuth(data) {
        let selected_files=[];
        let { preauthSchema ,preauthFileSchema} = this.state;
        let { submitPreauth } = networkList;
        let error = this.validateModalFeilds(preauthSchema);
        let tpacode, tpaname, zone_id, zone_val, insurance_val, insurance_id;
        preauthSchema.map((item) => {
            if (item.name === "payer") {
                tpaname = item.text ? item.text : '';
                tpacode = item.value ? item.value : '';
            }
            if (item.name === 'zone') {
                zone_val = item.value?item.text ? item.text : '':'';
                zone_id = item.value ? item.value : '';
            }
            if (item.name === 'insurance_company_name') {
                insurance_val = item.value?item.text ? item.text : '':'';
                insurance_id = item.value ? item.value : '';
            }
        });
        preauthFileSchema.map((data, secKey) => {
            data['Specification']['table_body'].map((table_body, table_key) => {
                table_body['feilds'].map((feilds, key) => {
                    if (feilds.name === "file_access" && feilds.value) { 
                        selected_files.push(feilds['file_upload_id'])
                    }
                });
            })
        })
        console.log('SELECTED FILES',selected_files)
        let user_data = ''
        if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
            user_data = JSON.parse(localStorage.getItem('user_data'));
        }
        console.log('SELECTED FILES11',user_data)
        if (!error.includes(false) && data !== 0 && data !== null && data !== undefined && data !== '') {
            this.setState({ commentModal: false, loadding: true });
            let payload = {
                "tpacode": tpacode,
                "tpaname": tpaname,
                "hospitalcode": data.unit_id ? data.unit_id : '',
                "unit_id": data.unit_id ? data.unit_id : '',
                "zone_id": zone_id,
                "zone_val": zone_val,
                "employeeid": "",
                "insurance_val": insurance_val,
                "insurance_id": insurance_id,
                "policyno": "",
                "patientfirstname": data.patient_name ?data.patient_name.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, ' '):'',
                "patientmiddlename": '',
                "patientlastname": "",
                "gender_val": "",
                "address": "",
                "mobileno": data.phone_number ? data.phone_number : '',
                "relationship_val": "Self",
                "relationship_id": "",
                "doa": data.admission_date ? data.admission_date : '',
                "doa_time": '',
                "dod": data.discharge_date ? data.discharge_date : '',
                "dod_time": '',
                "durationofstay": '',
                "ipnumber": data.ip_no ? data.ip_no : '',
                "umrnumber": data.umr_no ? data.umr_no : '',
                "counselling_id": data.counsellng_id,
                "e_date_of_admission": data.e_date_of_admission ? data.e_date_of_admission : '',
                "previous_payer_responce": data.payer_response ? data.payer_response : '',
                'previous_rn_reference_number': data.rn_reference_number ? data.rn_reference_number : '',
                'previous_rn_history_id': data.rn_history_id ? data.rn_history_id : '',
                'selected_files':selected_files ? selected_files:'',
                'fk_admission_id':data.fk_admission_id
            }
            try {
                postService('submitPreauth1', 'POST', {
                    'data':
                         payload

                }).then(res => {
                    if (res.status) {
                        preauthSchema.map((item) => {
                            if (item.name === "payer") {
                                item.text = null;
                                item.value = null;
                            }
                            if (item.name === 'zone') {
                                item.text = null;
                                item.value = null;
                                item.disable = true;
                            }
                            if (item.name === 'insurance_company_name') {
                                item.disable = true;
                                item.text = null;
                                item.value = null;
                            }
                        });
                        setTimeout(() => { this.setState({ preauthSchema: preauthSchema, preauthdata: [] }) }, 1000)
                        this.setState({
                            loadding: false,
                            preauthSchema: preauthSchema
                        })
                        this.renderBody();
                        Modal.success({
                            title: 'Success message',
                            content: res.message ? res.message : 'consent Added Successfully',
                        }
                        );
                    } else {
                        this.setState({ commentModal: false });
                        preauthSchema.map((item) => {
                            if (item.name === "payer") {
                                item.text = null;
                                item.value = null;
                            }
                            if (item.name === 'zone') {
                                item.text = null;
                                item.value = null;
                                item.disable = true;
                            }
                            if (item.name === 'insurance_company_name') {
                                item.disable = true;
                                item.text = null;
                                item.value = null;
                            }
                        });
                        setTimeout(() => { this.setState({ preauthSchema: preauthSchema }) }, 1000)
                        this.setState({
                            loadding: false,
                            preauthSchema: preauthSchema
                        })
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                        })
                    }
                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ loadding: false }));

                Modal.error({
                    title: 'Failure',
                    content: 'Oops, something is wrong. Please try again.',
                })

            }
        }
    }
    validateModalFeilds(formFeilds) {

        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if ((feild['element'] === 'select2')) {
                formFeilds[key]['errors'] = [];
                if (!feild.disable && feild.visible) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {

                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                errors.push(false);
                            }
                            else {
                                console.log('no', feild['name'], feild['value'])
                                formFeilds[key]['errors'] = [];
                                errors.push(true);
                            }
                        })

                }
            }
        })

        this.setState((state) => ({ formFeilds: formFeilds }));
        return errors;
    }
    preAuthModelClose() {
        let { preauthSchema } = this.state;
        preauthSchema.map((item) => {
            if (item.name === "payer") {
                item.text = null;
                item.value = null;
            }
            if (item.name === 'zone') {
                item.text = null;
                item.value = null;
                item.disable = true;
            }
            if (item.name === 'insurance_company_name') {
                item.disable = true;
                item.text = null;
                item.value = null;
            }
        });

        this.setState({ preauthSchema: preauthSchema, commentModal: false });
    }
    viewHistoryModelClose() {
        this.setState({ viewHistory: false })
    }
    handleChange(body) {
        let { preauthFileSchema,preauthSchema } = this.state;
        preauthFileSchema.map((data, secKey) => {
            data['Specification']['table_body'].map((table_body, table_key) => {
                table_body['feilds'].map((feilds, key) => {
                    if (feilds.name === body.name && feilds.id === body.id) {
                        preauthFileSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = body.value;
                    }
                })
            })
        })
        if (body.name === 'payer') {
            preauthSchema.map((item) => {
                if (item.name === body.name) {
                    localStorage.setItem('payercode', item.value);
                }
                if (item.name === 'zone') {
                    item.text = null;
                    item.value = null;
                    item.disable = false;
                }
                if (item.name === 'insurance_company_name') {
                    item.disable = false;
                    item.text = null;
                    item.value = null;
                }
            })
        }

        this.setState({
            preauthFileSchema: preauthFileSchema,preauthSchema:preauthSchema
        })
    }
    deleteRow(data) {

    }
    downloadPDF = (pdfLink) => {
        try {
            // Create a temporary link element
            const link = document.createElement('a');
            link.href = pdfLink;
            link.setAttribute('target', '_blank'); // Open in a new tab
            link.setAttribute('download', 'patient_bill.pdf');
    
            // Simulate click to trigger download
            document.body.appendChild(link);
            link.click();
    
            // Clean up
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading PDF:', error);
        }
    }


    ///////////////////////////////

 //nme clearance form
    // addInsuranceForm = async (body) => {
    //     this.setState({ nme_clearance_form: true, patient_details: body });
    //     await this.setStateAsync({ patient_details: body });   
    //     try {
    //         let user_data = JSON.parse(localStorage.getItem('user_data'));
    //         let payload = {
    //             unit_id: user_data['unitid'] && user_data['unitid'],
    //             ip_no: this.state.patient_details.ip_no || null,
    //             umr_no: this.state.patient_details.umr_no || null,
    //         };
    //         const res = await postService('getNmeClearance', 'POST', { data: payload });
    //         console.log('Res', Object.keys(res.data).length);
    //         this.setState({ 
    //             totalBillAmount: res.data.total_bill_amount, 
    //             insuranceApproveAmount: res.data.insurance_approved_amount, 
    //             lessAdvance: res.data.advance
    //         });
    //         this.calculatePayableAmount();
    //     } catch (error) {
    //         console.error("Error occurred: ", error);
    //     }
    // }
    addInsuranceForm = async (body) => {
        this.setState({ nme_clearance_form: true, patient_details: body });
        await this.setStateAsync({ patient_details: body });   
        try {
            let user_data = JSON.parse(localStorage.getItem('user_data'));
            let payload = {
                unit_id: user_data['unitid'] && user_data['unitid'],
                ip_no: this.state.patient_details.ip_no || null,
                umr_no: this.state.patient_details.umr_no || null,
            };
            const res = await postService('getNmeClearance', 'POST', { data: payload });
            const dataLength = Object.keys(res.data).length;
            console.log('NMELEngth', dataLength);
            
            // Check if dataLength is greater than 7
            if (dataLength > 7) {
                this.setState({ 
                    totalBillAmount: res.data.total_amount ? res.data.total_amount : 0, 
                    insuranceApproveAmount: res.data.insurance_approved_amount ? res.data.insurance_approved_amount : 0, 
                    lessAdvance: res.data.advance,
                    coPayAmount: res.data.co_pay_amount,
                    differenceAmount: res.data.difference_nme_amount,
                    payableAmount: res.data.payable_after_insurance_approval,
                    discountAmount: res.data.discount,
                    netPayableAmount: res.data.net_payable,
                    finalAmount: res.data.final_amount,
                    insuranceCleranceRemarks: res.data.remarks,
                    responseLength: true,
                    selectOptions: res.data.insurance_tpa_name,
                });
            } else {
                this.setState({ 
                    totalBillAmount: res.data.total_bill_amount ? res.data.total_bill_amount : 0, 
                    insuranceApproveAmount: res.data.insurance_approved_amount ? res.data.insurance_approved_amount : 0, 
                    lessAdvance: res.data.advance,
                    coPayAmount: 0,
                    differenceAmount: 0,
                    payableAmount: 0,
                    discountAmount: 0,
                    netPayableAmount: 0,
                    finalAmount: 0,
                    selectOptions: 0,
                    responseLength: false,
                });
            }
            this.calculatePayableAmount();
        } catch (error) {
            console.error("Error occurred: ", error);
        }
    }
    
    
    // Helper function to promisify setState
    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve);
        });
    }
    
    

      cancelInsuranceForm = () => {
        this.setState({nme_clearance_form: false, totalBillAmount: '0', insuranceApproveAmount: '0', coPayAmount: '0', differenceAmount: '0',payableAmount: '0',discountAmount: '0', netPayableAmount: '0', lessAdvance: '0', finalAmount: '0'})
      }

      handleDropdownVisibleChange = (open) => {
        if (open && this.state.select_options.length === 0) {
            this.fetchOptions();
        }
        this.setState({ dropdownVisible: open });
    };

    fetchOptions = () => {
        let user_data = JSON.parse(localStorage.getItem('user_data'));
        let payload = {
            unit_id: user_data && user_data.unitid,
        };

        this.setState({ fetching: true });

        postService('getAllTpas', 'POST', { data: payload }).then((res) => {
            if (res.status) {
                const selectOptions = res.data.map((data) => ({
                    id: data.id,
                    tpa_name: data.tpa_name,
                }));
                this.setState({ select_options: selectOptions, fetching: false });
            } else {
                this.setState({ select_options: [], fetching: false });
            }
        });
    };

    tpaHandleChange = (selectedValues) => {
        console.log('selectedValues:::::', selectedValues)
        this.setState({ selectedOptions: selectedValues || []});
    };
    // handleCoPayAmountChange = (e) => {
    //     const value = e.target.value;
    //     console.log('CoPayValue', value);
    //     if (/^\d*$/.test(value)) {
    //         const { totalBillAmount, insuranceApproveAmount } = this.state;
    //         // Convert null values to 0 if they are not defined
    //         const totalBillAmountNumeric = parseFloat(totalBillAmount) || 0;
    //         const insuranceApproveAmountNumeric = parseFloat(insuranceApproveAmount) || 0;
    //         // Perform calculations
    //         const sumCoPayAmount = totalBillAmountNumeric + parseFloat(value) - insuranceApproveAmountNumeric;
    //         this.setState({ coPayAmount: value, payableAmount: sumCoPayAmount });
    //     }
    // }
    handleCoPayAmountChange = (e) => {
        const value = e.target.value;
        console.log('CoPayValue', value);
    
        if (/^\d*$/.test(value)) {
            const { totalBillAmount, insuranceApproveAmount } = this.state;
            // Convert null values to 0 if they are not defined
            const totalBillAmountNumeric = parseFloat(totalBillAmount) || 0;
            const insuranceApproveAmountNumeric = parseFloat(insuranceApproveAmount) || 0;
            // Perform calculations
            const sumCoPayAmount = totalBillAmountNumeric + parseFloat(value || 0) - insuranceApproveAmountNumeric;
            this.setState({ coPayAmount: value, payableAmount: sumCoPayAmount });
        }
    }
    
    handleCoPayAmountBlur = () => {
        const { coPayAmount } = this.state;
        if (coPayAmount === '') {
            this.setState({ coPayAmount: '0' });
        }
    }

    handleDifferenceAmountChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            const { totalBillAmount, insuranceApproveAmount,coPayAmount} = this.state;
            console.log();
            const totalBillAmountNumeric = parseFloat(totalBillAmount) || 0;
            const insuranceApproveAmountNumeric = parseFloat(insuranceApproveAmount) || 0; 
            const sumDiffAmount = (parseFloat(totalBillAmountNumeric)) + parseFloat(coPayAmount)  + parseFloat(value || 0) - parseFloat(insuranceApproveAmountNumeric);
            this.setState({ differenceAmount: value, netPayableAmount : sumDiffAmount, payableAmount: sumDiffAmount});
        }
    }

    handleDifferenceAmountBlur = () => {
        const { differenceAmount } = this.state;
        if (differenceAmount === '') {
            this.setState({ differenceAmount: '0' });
        }
    }
    handleDiscountAmountChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            const {totalBillAmount, coPayAmount,differenceAmount,insuranceApproveAmount} = this.state;
            const totalBillAmountNumeric = parseFloat(totalBillAmount) || 0;
            const insuranceApproveAmountNumeric = parseFloat(insuranceApproveAmount) || 0; 
        const sumDiscountAmount =( (parseFloat(totalBillAmountNumeric)) + parseFloat(coPayAmount) +  parseFloat(differenceAmount))-  parseFloat(value || 0) - parseFloat(insuranceApproveAmountNumeric);
            this.setState({ discountAmount: value, payableAmount: sumDiscountAmount});
        }
    }

    handleDiscountAmountBlur = () => {
        const { discountAmount } = this.state;
        if (discountAmount === '') {
            this.setState({ discountAmount: '0' });
        }
    }

    calculatePayableAmount = () => {
        const { totalBillAmount, insuranceApproveAmount, discountAmount, coPayAmount, differenceAmount } = this.state;
        // Convert null values to 0 if they are not defined
        const totalBillAmountNumeric = parseFloat(totalBillAmount) || 0;
        const insuranceApproveAmountNumeric = parseFloat(insuranceApproveAmount) || 0;
        const discountAmnt = parseFloat(discountAmount) || 0;
        const coPyAmt = parseFloat(coPayAmount) || 0;
        const diffAmt = parseFloat(differenceAmount) || 0;
        // Perform calculations
        const payableAmount = (totalBillAmountNumeric + coPyAmt + diffAmt) - (Math.abs(discountAmnt - insuranceApproveAmountNumeric));
        this.setState({ payableAmount: payableAmount });
    }

    netPayableAmount = () => {
        const { totalBillAmount, insuranceApproveAmount, discountAmount, coPayAmount, differenceAmount} = this.state;
        console.log('STATEVALUE::::', this.state);
        const differenceAmountNumeric = parseFloat(differenceAmount);
        const coPayAmountNumeric = parseFloat(coPayAmount);
        const netPayableAmount = totalBillAmount - insuranceApproveAmount - discountAmount + coPayAmountNumeric + differenceAmountNumeric;
        this.setState({ netPayableAmount: netPayableAmount });
    }    

    submitConsent = async() => {
        const {responseLength,insuranceCleranceRemarks,discountAmount,lessAdvance,differenceAmount,payableAmount, patient_details, selectedOptions, totalBillAmount, insuranceApproveAmount, coPayAmount, netPayableAmount} = this.state;
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        let payableAfterInsuranceApproved = totalBillAmount -  insuranceApproveAmount;
        let finalAmountValue = payableAmount - lessAdvance;
        console.log('', selectedOptions)
        if (selectedOptions.length === 0) {
            // Display error message
            // For example, using Modal.error() or setting an error state to display in the UI
            return Modal.error({
                title: 'Error',
                content: 'Please select TPA Name',
                zIndex: 1050,
            });
        }
        try{
            if (payableAmount === 0) {
                Modal.warning({
                    title: 'Error',
                    content: 'Final amount cannot be 0.',
                    zIndex: 1050,
                });            
            }
            
            else{
                postService('insertNmeClearance', 'POST', {
                    "data": {
                      "patient_name": patient_details.patient_name ? patient_details.patient_name : null,
                      "ip_no": patient_details.ip_no ? patient_details.ip_no : null,
                      "umr_no": patient_details.umr_no ? patient_details.umr_no : null,
                      "unit_id": patient_details.unit_id ? patient_details.unit_id : null,
                      "insurance_tpa_name": selectedOptions,
                      "total_amount": totalBillAmount ? totalBillAmount : 0,
                      "insurance_approved_amount": insuranceApproveAmount ? insuranceApproveAmount : 0,
                      "co_pay_amount": coPayAmount ? coPayAmount : 0,
                      "difference_nme_amount": differenceAmount ? differenceAmount : 0,
                      "payable_after_insurance_approval": payableAfterInsuranceApproved ? payableAfterInsuranceApproved : 0,
                      "discount": discountAmount ? discountAmount : 0,
                      "net_payable": payableAmount ? payableAmount : 0,
                      "advance": lessAdvance ? lessAdvance : 0,
                      "final_amount": finalAmountValue ? finalAmountValue : 0,
                      "remarks": insuranceCleranceRemarks,
                      "created_by": user_data['id'] ? user_data['id'] : null,
                    }
                  }).then(res => {
                    console.log('comments:', res);                
                    if (res.success) {
                        this.handlePrint();
                        let This=this
                        const tableHeadData = `insuranceclearanceform`;
                        const patientChecklistPreview = document.getElementById(tableHeadData);
                        // if (patientChecklistPreview !== null && patientChecklistPreview !== '' && patientChecklistPreview !== undefined){
                        //     console.log("2222222222222222222222", );
                        //     // html2PDF(patientChecklistPreview,{
                        //         const pdfConfig = {
                        //         image: { type: 'png', quality: 0.20 },
                        //         jsPDF: { format: 'a4' },
                        //         html2canvas: {
                        //             scrollX: 0,
                        //             scrollY: -window.scrollY,
                        //             useCORS: true,
                        //         },
                        //         theme: 'plain',
                        //         styles: {
                        //             fontSize: 2,
                        //             cellPadding: 0.75,
                        //             lineColor: [200, 200, 200],
                        //             lineWidth: 0.1,
                        //             valign: 'middle',
                        //             halign: 'center',
                        //             fillColor: [255, 255, 255],
                        //         },
                        //         margin: { top: 80, right: 20, bottom: 40, left: 20 },
                        //         imageType: 'image/jpeg',
                        //         output: './images/nmeClearance.pdf',
                        //         success: function (pdf) {
                        //             const blob = pdf.output('blob');
                        //             const form_data = new FormData();
                        //             form_data.append('upfile', blob);
                        //             form_data.append('umr', patient_details.umr_no);
                        //             form_data.append('ip', patient_details.ip_no);
                        //             form_data.append('unit_id', patient_details.unit_id);
                        //             // form_data.append('phone_no', digiSignPhone);
                        //             postService('nmeClearanceFileUpload', 'POST', form_data).then(res => {
                        //                 console.log('PDDD::::', res);
                        //                 debugger;
                        //                 if (res.status) {
                        //                     localStorage.setItem('completed_counselling_date', moment());
                        //                     // This.props.next();
                        //                     // This.setState({ loadding: false });
                        //                 }
                        //             });
                        //         }
                        //     };
                        //     html2PDF(patientChecklistPreview, pdfConfig);
                        //     // }); 
                        // }  
                        if (patientChecklistPreview !== null && patientChecklistPreview !== '' && patientChecklistPreview !== undefined) {
                            console.log("Generating PDF...");
                        
                            const pdfConfig = {
                              image: { type: 'png', quality: 0.20 },
                              jsPDF: { format: 'a4' },
                              html2canvas: {
                                scrollX: 0,
                                scrollY: -window.scrollY,
                                useCORS: true,
                              },
                              theme: 'plain',
                              styles: {
                                fontSize: 2,
                                cellPadding: 0.75,
                                lineColor: [200, 200, 200],
                                lineWidth: 0.1,
                                valign: 'middle',
                                halign: 'center',
                                fillColor: [255, 255, 255],
                              },
                              margin: { top: 100, right: 20, bottom: 40, left: 20 },
                              imageType: 'image/jpeg',
                              output: './images/nmeClearance.pdf',
                              success: function (pdf) {
                                const blob = pdf.output('blob');
                                const form_data = new FormData();
                                form_data.append('upfile', blob);
                                form_data.append('umr', patient_details.umr_no);
                                form_data.append('ip', patient_details.ip_no);
                                form_data.append('unit_id', patient_details.unit_id);
                                postService('nmeClearanceFileUpload', 'POST', form_data).then(res => {
                                  console.log('PDF upload response:', res);
                                  if (res.status) {
                                    localStorage.setItem('completed_counselling_date', moment());
                                  }
                                });
                        
                                // Trigger print dialog
                                const pdfURL = URL.createObjectURL(blob);
                                const newWindow = window.open(pdfURL, '_blank');
                                if (newWindow) {
                                  newWindow.addEventListener('load', () => {
                                    newWindow.print();
                                  });
                                }
                              }
                            };
                        
                            html2PDF(patientChecklistPreview, pdfConfig);
                          }  
                          console.log("PDF generation and print process completed.");
                        
                          Modal.success({
                            title: 'Success',
                            content: res.message ? res.message : "Success",
                            zIndex: 1022
                          }); 
                          this.setState({
                            nme_clearance_form: false,
                            totalBillAmount: 0,
                            insuranceApproveAmount: 0,
                            coPayAmount: 0,
                            differenceAmount: 0,
                            payableAmount: 0,
                            netPayableAmount: 0,
                            discountAmount: 0,
                            lessAdvance: 0,
                            finalAmount: 0
                          });
                        console.log("333333333333333333");           
                        Modal.success({
                            title: 'Success',
                            content: res.message ? res.message : "Success",
                            zIndex: 1022
                        }); 
                        this.setState({nme_clearance_form: false,totalBillAmount: 0, insuranceApproveAmount: 0, coPayAmount: 0, differenceAmount: 0, payableAmount: 0, netPayableAmount: 0, discountAmount: 0, lessAdvance: 0, finalAmount: 0}, () => {
                            // this.handlePrint();
                        });                
                    } else {
                        Modal.error({
                            title: 'Failure',
                            content: res.errors ? res.errors : "Oops! something went wrong... Please try again.",
                            zIndex: 1022
                        });
                    }
                });
            }
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        } 
      };


handlePrint = async() => {
        // Hide the input field by updating the state
        this.setState({ showInput: false });
        const input = document.getElementById('insuranceclearanceform');
        html2canvas(input, {
            scale: 2, 
            logging: true, 
            letterRendering: true,
            allowTaint: true,
            useCORS: true,
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'px', 'a4');
            const width = pdf.internal.pageSize.getWidth();
            const height = pdf.internal.pageSize.getHeight();
            pdf.addImage(imgData, 'PNG', 0, 0, width, height);
            pdf.autoPrint();
            window.open(pdf.output('bloburl'), '_blank');
            // After printing, show the input field again
        this.setState({ showInput: true });
        });
};



   
    handleInsuranceClearanceInputChange = (event) => {
        this.setState({ insuranceCleranceRemarks: event.target.value });
    };
    
    render() {
        // let { tbody, tableHead, previlege_data, total_items, page_data_count, page_length, download_btn, downloadStatus, filename, downloadtbody, downloadthead, activePage, formData, commentModal, preauthSchema, preauthdata, viewpdf, ViewURLPDF, viewHistory, patientHistory, thead, umr_no, ip_no, patient_name, preAuthFile, patientDocument, checked, preauthFileSchema } = this.state;
        let {selectedOptions,currentDate,insuranceCleranceRemarks,lessAdvance,selectOptions,finalAmount,netPayableAmount,responseLength,patient_details,totalBillAmount, insuranceApproveAmount, payableAmount,coPayAmount, differenceAmount, discountAmount,fetching, select_options, dropdownVisible, tbody, tableHead, previlege_data, total_items, page_data_count, page_length, download_btn, downloadStatus, filename, downloadtbody, downloadthead, activePage, formData, commentModal, preauthSchema, preauthdata, viewpdf, ViewURLPDF, viewHistory, patientHistory, thead, umr_no, ip_no, patient_name, preAuthFile, patientDocument, checked, preauthFileSchema, nme_clearance_form, onCancel} = this.state;
        let userData = localStorage.getItem('user_data');
        const dateString = currentDate.toDateString(); 
        if (userData !== undefined && userData !== null && userData !== '') {
            userData = JSON.parse(userData);
        }
        let roleid=  userData ? userData['roleid'] :null;
        return (
            <div>
                <div className="clearfix mx-5 mb-3">
                            
                <div className="float-left pt-2">
                Post-Auth Worklist
                    </div>
                    <div className="float-left pt-2">
                    </div>
                    <div className="float-right download sticky-top d-flex flex-row-reverse">
                        {
                            (tbody && tbody.length !== 0)
                                ?
                                <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                    <button className="btn btn-success text-capitalize" onClick={() => { this.downloadFile() }}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Worklist</span></button>
                                <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />
                                    <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined className="align-middle pr-2" /><span> Clear</span></button>
                                    <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></button>
                                </div>
                                :
                                <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                    <Button className="btn btn-success-disabled text-capitalize" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Worklist</span></Button>
                                    <button className="btn btn-light text-capitalize py-1 mr-3 " onClick={() => { this.clearFilter() }}><UndoOutlined type="reload" className="align-middle pr-2" /><span> Clear</span></button>
                                    <Button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></Button>
                                </div>
                        }
                    </div>
                </div>
                <div className="card mx-5 mb-5 card-table">
                    <div className="card-header bg8">
                        <div className="clearfix">
                            <div className=" row">
                                {(formData !== undefined) && <React.Fragment>

                                    {formData
                                        .map((feild, key) => {

                                            if (feild.element === 'input') {
                                                return (
                                                    <React.Fragment key={key}>
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            <div className="input-group" key={key}>
                                                                {/* <input type="text" id="myInput" className="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" /> */}
                                                                <div
                                                                    className='w-100'
                                                                    key={key}>
                                                                    <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR" onBlur={this.searchChange.bind(this)} ref={(inputRef => (this.inputRef = inputRef))} />
                                                                    <div class="input-group-append" style={{ position: 'absolute', right: 0, height: '32px', top: 0 }}>
                                                                        <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="input-group-append" style={{position: 'absolute', right: 0, height: '32px'}}>                                                                    
                            <button className="btn btn-primary btn-sm" onClick={this.search}><img src="/assets/images/icons/search.png" /></button>
                        </div> */}
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }
                                            if (feild.element === 'select2') {
                                                return (
                                                    <React.Fragment key={key}>
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            {/* <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text2}</p> */}
                                                            <Select2
                                                                Queuedata={formData}
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}
                                                                onselectChanges={this
                                                                    .handleChange
                                                                    .bind(this)}
                                                            /> {feild
                                                                .errors
                                                                .map((error, eKey) => {
                                                                    return (
                                                                        <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                    );
                                                                })}
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }
                                            if (feild.element === 'select2multiple' && feild.visible) {
                                                return (
                                                    <React.Fragment key={key}>
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            <Select2multiple
                                                                Queuedata={formData}
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}
                                                                onselectChanges={this
                                                                    .handleChange
                                                                    .bind(this, feild)}
                                                            /> {feild
                                                                .errors
                                                                .map((error, eKey) => {
                                                                    return (
                                                                        <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                    );
                                                                })}
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }
                                            if (feild.element === 'daterange') {
                                                return (
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}

                                                        <DateRange
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }) }}
                                                        />
                                                        <div class="input-group-append">
                                                            <button class="btn btn-primary btn-sm ml-1" onClick={this.dateRange}>Go</button>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })}

                                </React.Fragment>}

                            </div>
                        </div>
                    </div>

                    <div className="financial-table table-responsive sticky-header" id="table">
                        <table className="table table-hover table-bordered mb-0 bg-white" style={{ width: '300%' }}>
                            <thead>
                                <tr>
                                    <td>S.no</td>
                                    {tableHead.map((head, key) => {
                                        return (<td key={key}>{head.text}</td>);
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {tbody.map((body, key) => {
                                    return (<tr key={key}>
                                        {/* onClick={this.navigateTo.bind(this,body)} style={{cursor: 'pointer'}} */}
                                        <td>{(key + 1) + (page_data_count > 1 ? 20 * (page_data_count > 2 ? (page_data_count - 1) : 1) : 0)}</td>
                                        {tableHead.map((head, Hkey) => {
                                            if (head['key'] === 'date_of_counselling') {
                                                return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                            }
                                            if (head['key'] === 'rn_preauth_submitted') {
                                                return (<td>{body[head['key']] ? body[head['key']] : 'NO'}</td>)
                                            }
                                            if (head['key'] === 'payer_reponse_remarks') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'fc_payer_type') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'hims_payer_type') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'rn_preauth_requested_time') {
                                                return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                            }
                                            if (head['key'] === 'rn_preauth_submitted_date') {
                                                return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                            }
                                            if (head['key'] === 'payer_updated_at') {
                                                return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                            }
                                            if (head['key'] === 'payer_approved_amount') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'remedinet_remarks') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            // if (head['key'] === 'approval_file_content') {
                                            //     if ((body['approval_file_content']) !== '' && (body['approval_file_content']) !== undefined && (body['approval_file_content']) !== null) {
                                            //         return (<td><FileDoneOutlined style={{ fontSize: '54px' }} onClick={this.modelVisisableViewpdf.bind(this, body['approval_file_content'])} /> </td>)
                                            //     } else {
                                            //         return (<td>--</td>);
                                            //     }

                                            // }
                                            if (head['key'] === 'approval_file_name') {
                                                if ((body['approval_file_name']) !== '' && (body['approval_file_name']) !== undefined && (body['approval_file_name']) !== null) {
                                                    return (
                                                    <td>
                                                        <a
                                                            href={`${UPLOAD_URL}${body['approval_file_name']}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            Open Document
                                                        </a>
                                                        {/* <FileDoneOutlined style={{ fontSize: '54px' }} onClick={this.modelVisisableViewpdf.bind(this, filePath)} /> */}
                                                         </td>
                                                )
                                                } else {
                                                    return (
                                                    <td>--</td>);
                                                }

                                            }
                                            if (head['key'] === 'is_lan_bill_prepared') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'corp_approx_final_bill_status') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'discharge_summary_approval_status') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'action') {
                                                const isRoleAllowed = roleid === ('RL_0rDv' || 'RL_ijmN' || 'RL_FFSn');
                                                const allowedRoles = ['RL_0rDv', 'RL_ijmN', 'RL_FFSn'];
                                                return (
                                                    <td>
                                                        {/* {!isRoleAllowed && (
                                                        <>
                                                            <Tooltip><img src={homepage+"/assets/images/upload.png"} alt="edit" style={{ marginTop: '5px' }} onClick={() => { this.openupload(body) }} /></Tooltip>
                                                            <New_Counselling_upload {...this.props} {...this.state} ref={instance => { this.child = instance }} />
                                                            <Tooltip title="Post-auth Submit"><SendOutlined className="p-2 border bg-success ml-1 text-white " style={{ verticalAlign: '-webkit-baseline-middle' }}
                                                                onClick={this.modelVisisablePostAuthSubmit.bind(this, body)}
                                                            />
                                                            </Tooltip>
                                                        </>
                                                        )} */}
                                                        {allowedRoles.includes(roleid) && (
                                                            <Tooltip title="Download All">
                                                                <DownloadOutlined className="p-2 border bg-success ml-1 text-white" style={{ verticalAlign: '-webkit-baseline-middle', pointerEvents: 'none', opacity: 0.5}} onClick={this.modelVisisablePostAuthSubmit.bind(this, body)}/>
                                                            </Tooltip>
                                                        )}
                                                        {allowedRoles.includes(roleid) && (
                                                            <Tooltip title="Download Bills">
                                                                {/* <DownloadOutlined className="p-2 border bg-success ml-1 text-white" style={{ verticalAlign: '-webkit-baseline-middle' }} onClick={() => this.downloadPDF(body['patient_bill_pdf_link'])}/> */}
                                                                {body['patient_bill_pdf_link'] ? (
                                                                <ProfileOutlined
                                                                    className="p-2 border bg-success ml-1 text-white"
                                                                    style={{ cursor: 'pointer', verticalAlign: '-webkit-baseline-middle' }}
                                                                    onClick={() => this.downloadPDF(body['patient_bill_pdf_link'])}
                                                                />
                                                                ) : (
                                                                    <ProfileOutlined
                                                                        className="p-2 border bg-success ml-1 text-white"
                                                                        style={{ verticalAlign: '-webkit-baseline-middle', pointerEvents: 'none', opacity: 0.5}}
                                                                    />
                                                                )}
                                                            </Tooltip>
                                                        )}
                                                        {allowedRoles.includes(roleid) && (
                                                            <Tooltip title="Download Discharge Summary">
                                                                <AlignLeftOutlined className="p-2 border bg-success ml-1 text-white" style={{ verticalAlign: '-webkit-baseline-middle', pointerEvents: 'none', opacity: 0.5}} onClick={this.modelVisisablePostAuthSubmit.bind(this, body)}/>
                                                            </Tooltip>
                                                        )}
                                                        {!allowedRoles.includes(roleid) && (
                                                        <Tooltip title={body['rn_reference_number'] ? "View History" : "No History"}><HistoryOutlined className="p-2 border  ml-1 text-white history_icon " style={{ verticalAlign: '-webkit-baseline-middle' }} onClick={body['rn_reference_number'] ? this.historyPreAuth.bind(this, body) : ''} /></Tooltip>
                                                        )}
                                                    </td>)
                                            }
                                            if (head['key'] === 'insurance') {
                                                return (
                                                    <td>
                                                        <div style={{marginLeft: '36px'}}>
                                                        <FileAddFilled
                                                                    title={"Add Nme Clearance"}
                                                                    className="p-2 border bg-success ml-1 text-white"
                                                                    style={{ cursor: 'pointer', verticalAlign: '-webkit-baseline-middle' }}
                                                                    onClick={() => this.addInsuranceForm(body)}
                                                        />  
                                                        </div>
                                                    </td>)
                                            }
                                            return (
                                                <td className="text-capitalize">
                                                    {(body[head['key']] !== null) ? body[head['key']] : 'NA'}
                                                </td>
                                            )

                                        })
                                        }

                                    </tr>)
                                })}
                                {(tbody && tbody.length === 0) && <React.Fragment>

                                    <tr>
                                        <td colSpan={tableHead.length + 1} className="text-center">
                                            <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                            <p className="no-data mb-0">No Data</p>
                                        </td>
                                    </tr>

                                </React.Fragment>}
                            </tbody>
                        </table>
                    </div>
                </div>
                {(this.state.loadding) && <div className="loadding"> <Spin tip="Loading..." size={'large'}></Spin></div>}
                <div className="col-6 offset-3 text-center mb-5 pb-5">
                    <Pagination current={page_data_count} total={total_items} itemRender={this.itemRender.bind(this)} pageSize={page_length} showSizeChanger={false} onChange={this.pageChange.bind(this)} />
                </div>
                <Modal
                    title=''
                    centere
                    footer={null}
                    width='95%'
                    height='95%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={commentModal}>
                    <Spin spinning={this.state.loadding} >
                        {commentModal &&
                            <React.Fragment>
                                <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.preAuthModelClose()} /></Tooltip>
                                <h4 className="text-center">Pre-Authorisation</h4>
                                <div className="row pb-3 pt-3">
                                    <div className="col-6 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_name ? patient_name : '--'}</Tooltip></h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="UMR Number">{umr_no ? umr_no : '--'}</Tooltip></h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="IP Number">{ip_no ? ip_no : '--'}</Tooltip></h6>
                                    </div>
                                </div>
                                <div className="justify-content-center">
                                    <div className="col-12" style={{ display: 'flex',paddingLeft:'0px' }}>
                                        {(preauthSchema !== undefined) && <React.Fragment>
                                            {preauthSchema
                                                .map((feild, key) => {
                                                    if (feild.element === 'select2') {
                                                        return (
                                                            <React.Fragment key={key}>

                                                                <div
                                                                    className={`${feild.className
                                                                        ? feild.className
                                                                        : 'col '} ${feild.name}`}
                                                                    key={key} style={{paddingLeft:'0px'}}>
                                                                    <p className="data-label mb-1 pt-1 pr-2">{feild.title}</p>
                                                                    <Select2
                                                                        Queuedata={formData}
                                                                        selectdata={feild}
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        onselectChanges={this
                                                                            .handleChange
                                                                            .bind(this)}
                                                                    /> {feild
                                                                        .errors
                                                                        .map((error, eKey) => {
                                                                            return (
                                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                            );
                                                                        })}
                                                                </div>

                                                            </React.Fragment>
                                                        )
                                                    }

                                                })}

                                        </React.Fragment>}
                                    </div>
                                </div>
                                {/* <p className="text-center mb-5">All files access in pre-auth submit </p> */}
                                <div className="justify-content-center">
                                <div className="financial-table table-responsive mt-5">
                                    {preauthFileSchema.map((feild, key) => {
                                        if (feild.visible) {
                                            return (<React.Fragment key={key}>
                                                <div className="d-inline-flex w-100">
                                                    <h4 className="data-label w-100" style={{ textTransform:'initial' }}>{feild.title}</h4>
                                                </div>
                                                <div className="financial-table table-responsive">
                                                    <Tableantd form_table={'additional_packages'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />

                                                </div>
                                            </React.Fragment>)
                                        }
                                    })}
                                </div>
                                </div>
                                
                                <div className="text-center">
                                    <button className="btn btn-success mt-5" onClick={() => { this.submitPreAuth(preauthdata) }}>Submit</button>
                                </div>

                            </React.Fragment>
                        }
                    </Spin>
                </Modal>
                <Modal
                    title=''
                    centere
                    footer={null}
                    width='70%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={viewpdf}>
                    <Spin spinning={this.state.loadding} >
                        <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.PDFModelClose()} /></Tooltip>
                        <div
                            style={{
                                border: '1px solid rgba(0, 0, 0, 0.3)',
                                height: '750px',
                            }}
                        >
                            {/* <embed src={`data:application/pdf;base64,${ViewURLPDF}`}   width="100%" height="100%" ></embed> */}
                            <embed src={`data:application/pdf;base64,${ViewURLPDF}`} width="100%" height="100%" ></embed>
                        </div>
                        {/* <embed src={`data:application/pdf;base64,${ViewURLPDF}`}   width="100%" ></embed>
                        <iframe src={`data:application/pdf;base64,${ViewURLPDF}`} width="100%"  ></iframe> */}
                        {/* <a href={`data:application/pdf;base64,${ViewURLPDF}`} download="file.pdf"></a> */}

                    </Spin>
                </Modal>

                <Modal
                    title=''
                    centere
                    footer={null}
                    width='95%'
                    height='95%'
                    zIndex={1021}
                    closable={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={viewHistory}>
                    <Spin spinning={this.state.loadding} >
                        {viewHistory &&
                            <React.Fragment>
                                <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.viewHistoryModelClose()} /></Tooltip>
                                <h4 className="text-center pb-3">Payer History</h4>
                                
                                <div className="row pb-3">
                                    <div className="col-6 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_name ? patient_name : '--'}</Tooltip></h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="UMR Number">{umr_no ? umr_no : '--'}</Tooltip></h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="IP Number">{ip_no ? ip_no : '--'}</Tooltip></h6>
                                    </div>
                                </div>
                                <div className="financial-table table-responsive pop-table">
                                    <table className="table table-hover table-bordered mb-0 bg-white">
                                        <thead style={{ backgroundColor: '#084b69' }} >
                                            <tr>
                                                {/* <td className="text-capitalize align-middle text-center">History ID</td> */}

                                                {thead.map((head, key) => {

                                                    return (<td className="text-capitalize align-middle" key={key} >{head['text']}</td>)
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {patientHistory.map((body, key) => {
                                                return (<tr key={key}>
                                                    {/* onClick={this.navigateTo.bind(this,body)} style={{cursor: 'pointer'}} */}
                                                    {/* <td>{(key + 1) + (page_data_count > 1 ? 20 * (page_data_count > 2 ? (page_data_count - 1) : 1) : 0)}</td> */}
                                                    {thead.map((head, Hkey) => {

                                                        if (head['key'] === 'payer_updated_time') {
                                                            return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                                        }
                                                        if (head['key'] === 'preauth_submited_time') {
                                                            return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                                        }
                                                        if (head['key'] === 'approveddate') {
                                                            return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                                        }
                                                        return (
                                                            <td className="text-capitalize">
                                                                {(body[head['key']] !== null && body[head['key']] !=='') ? body[head['key']] : '--'}
                                                            </td>
                                                        )

                                                    })
                                                    }

                                                </tr>)
                                            })}
                                            {(patientHistory && patientHistory.length === 0) && <React.Fragment>

                                                <tr>
                                                    <td colSpan={tableHead.length + 1} className="text-center">
                                                        <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                        <p className="no-data mb-0">No Data</p>
                                                    </td>
                                                </tr>

                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                                    <div className="text-center m-4">
                                        <button className="btn btn-next" onClick={() => this.viewHistoryModelClose()}> Close</button>
                                    </div>
                                    {/* {docTypes.map((data, key) => {
                            return (
                                <div className="d-flex flex-column mb-3">
                                    <div className="d-inline-flex w-100">
                                        <span className="mt-1 w-75"> {key + 1}. {data.document_type}</span>
                                        
                                        {(data.status !== true) && <Uploadlayer {...this.props} {...this.state} />}
                                    </div>                                    
                                        {data.status && <span class="badge badge-success my-auto" style={{width: '60px'}}>Verified</span>}
                                        {(data.status == false) && <span class="badge badge-danger my-auto" style={{width: '60px'}}>Rejected</span>}
                                     <span><a href="#" target="_blank">{data.preupload}</a></span>
                                </div>
                            )
                        })} */}
                                </div>

                            </React.Fragment>
                        }
                    </Spin>
                </Modal>
                {responseLength ? (
                    <Modal
                    centered
                    visible={nme_clearance_form}
                    width='50%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    footer={null}
                >
                    {/* <div id="print-content" id='insuranceclearanceform'> */}
                    <div id='insuranceclearanceform'>
                    <Tooltip title='Close'><CloseOutlined type="close" className=" popup-close" onClick={() => this.setState({nme_clearance_form: false})} /></Tooltip>
                        <React.Fragment>
                            <h4 className="text-center">KIMS Hospitals,{patient_details.unit_name ? patient_details.unit_name : '--'}</h4>
                            <h4 className="text-center">Insurance Clearance Form</h4>
                        </React.Fragment>
                   <div id="print-content">
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'50px'}}>Date: <span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize'}}>{dateString}</span></h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'162px' }}>Insurance / TPA Name:</h8>
                            </div>
                        </div>
                        <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'13px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'374px'}}>
                                <span style={{color: '#455a64', fontSize:'11px', fontWeight: 'normal', textTransform: 'capitalize'}}>{Object.keys(selectOptions).length ? selectOptions : '--'}</span>
                                </h8>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Patient Name : <span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize'}}>{patient_details.patient_name ? patient_details.patient_name : '--'}</span></h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'24px'}}>Admission No: <span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize'}}>{patient_details.ip_no ? patient_details.ip_no : '--'}</span></h8>
                            </div>
                        </div>
                        <div style={{border:'1px solid', width: '650px', marginTop:'15px'}}></div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Total Bill Amount:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'149px'}}>{totalBillAmount}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Insurance Approve Amount:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'64px'}}>{insuranceApproveAmount}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                        <h8 style={{color: '#455a64', fontSize:'16px', fontWeight: 'bold', textTransform: 'capitalize',marginLeft:'48px', textDecoration: 'underline'}}>Deductions</h8>
                            <div class="col-12 p-0" style={{marginTop: '12px'}}>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Co-Pay Amount:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'154px'}}>{coPayAmount}</span></h8>

                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Difference Amount/NME's:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'82px'}}>{differenceAmount}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Payable after insurance approval:</h8>
                            {/* <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'142px'}}>{totalBillAmount - insuranceApproveAmount}</span></h8> */}
                            <h8 style={{color: '#b37f40', fontSize: '16px', fontWeight: 'normal', textTransform: 'capitalize'}}>
                                <span style={{color: '#455a64', fontSize: '16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft: '142px'}}>
                                    {Math.abs(totalBillAmount - insuranceApproveAmount)}
                                </span>
                            </h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Discount if any:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'292px'}}>{discountAmount}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Net Payable:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'250px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'64px'}}>{Math.abs(netPayableAmount)}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Less Advance:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'174px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}>{lessAdvance}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>{(payableAmount - lessAdvance) < 0 ? "Refund" : "To Collect"}</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'292px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:(finalAmount) < 0 ? '64px' : '42px'}}>{Math.abs(finalAmount)}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Remarks:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'270px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'70px'}}>{insuranceCleranceRemarks}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0" style={{marginTop:'30px'}}>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>(Authorized Signature)</h8>
                            </div>
                        </div>
                        <div style={{marginTop: '30px'}}>
                        <h8 style={{color: '#455a64', fontSize:'16px', fontWeight: 'bold', textTransform: 'capitalize',marginLeft:'48px', textDecoration: 'underline'}}>Details for NEFT/RTGS Refund</h8>
                        </div>
                        <table style={{ marginTop: '20px', marginLeft: '50px', borderCollapse: 'collapse', border: '1px solid black' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Name of the A/c holder</td>
                                                    <td style={{ border: '1px solid black', padding: '8px', width: '356px'}}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Name of the Bank</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Name of the branch</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>A/c Number</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>IFSC Code</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Relation with patient</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Contact Number</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>

                                            </tbody>
                                        </table>
                            <div className="row w-100 mx-auto mt-3">
                                <div class="col-12 p-0" style={{marginTop: '50px'}}>
                                <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Signature of the patient / Attendant</h8>
                                <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}>Audit Signature</h8>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div className="fc-patient-copy">
                                                <div className="row justify-content-center p-4 pt-4 m-0">
                                                    {/* <ReactToPrint
                                                        trigger={() => <button className="btn btn-success d-print-none text-capitalize">Print</button>}
                                                        content={() => this.componentRef}
                                                    /> */}
                                                    {/* <ReactToPrint
                                                        trigger={() => <Button type="primary">Print</Button>}
                                                        content={() => this.componentRef.current}
                                                    /> */}
                                                    <button className="btn btn-success d-print-none text-capitalize" onClick={this.handlePrint}>Print</button>
                                                </div>
                                            </div>
                </Modal>
                ) : (
                    <Modal
                    centered
                    visible={nme_clearance_form}
                    width='50%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    footer={null}
                >
                    <Tooltip title='Close'><CloseOutlined type="close" className=" popup-close" onClick={() => this.setState({nme_clearance_form: false})} /></Tooltip>
                       {/* <div id="print-content"> */}
                       <div id="insuranceclearanceform">
                       <style>
                    {`
                        @media print {
                            #print-content .ant-select-single .ant-select-selector {
                                display: none !important;
                            }
                        }
                    `}
                </style>
                        <React.Fragment>
                            <h4 className="text-center">KIMS Hospitals,{patient_details.unit_name ? patient_details.unit_name : '--'}</h4>
                            <h4 className="text-center">Insurance Clearance Form</h4>
                        </React.Fragment>
                    <div className=" row">
                                    <div className="col-6 mx-auto" style={{marginTop:'40px'}}>
                                    
                                    </div>
                    </div>
                   <React.Fragment>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'50px'}}>Date: <span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize'}}>{dateString}</span></h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'137px' }}>Insurance / TPA Name:</h8>
                            </div>
                        </div>
                        <div class="col-12 p-0">
                        {this.state.showInput ? (
                        <Select
                                                    mode="single"
                                                    showArrow={true}
                                                    showSearch={true}
                                                    allowClear={true}
                                                    style={{ width: '250px',marginTop:'10px', marginLeft:'373px',display: 'none !important'}}
                                                    placeholder="Select an Insurance Company"
                                                    loading={fetching}
                                                    onDropdownVisibleChange={this.handleDropdownVisibleChange}
                                                    dropdownVisible={dropdownVisible}
                                                    onChange={this.tpaHandleChange}
                                                    onBlur={() => this.setState({ selectTouched: true })}
                                                >
                                                    {select_options.map((option) => (
                                                        <Select.Option key={option.id} value={option.id}>
                                                            {option.tpa_name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>) :(
                                            // <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'64px'}}>{selectedOptions}</span></h8>    
                                            <h8 style={{color: '#b37f40', fontSize:'13px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'374px'}}>
                                            <span style={{color: '#455a64', fontSize:'11px', fontWeight: 'normal', textTransform: 'capitalize'}}>{selectedOptions}</span>
                                            </h8>)
                                            }
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Patient Name : <span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize'}}>{patient_details.patient_name ? patient_details.patient_name : '--'}</span></h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}>Admission No: <span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize'}}>{patient_details.ip_no ? patient_details.ip_no : '--'}</span></h8>
                            </div>
                        </div>
                        <div style={{border:'1px solid', width: '650px', marginTop:'15px'}}></div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Total Bill Amount:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'149px'}}>{totalBillAmount}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Insurance Approve Amount:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'64px'}}>{insuranceApproveAmount}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                        <h8 style={{color: '#455a64', fontSize:'16px', fontWeight: 'bold', textTransform: 'capitalize',marginLeft:'48px', textDecoration: 'underline'}}>Deductions</h8>
                            <div class="col-12 p-0" style={{marginTop: '12px'}}>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Co-Pay Amount:</h8>
                            {/* <Input
                                            placeholder='Co-pay Amount'
                                            style={{ width: '140px', fontSize:'16px', marginLeft: '268px'}}
                                            value={coPayAmount}
                                            onChange={this.handleCoPayAmountChange}
                                            /> */}
                                             {/* {this.state.showInput ? (
                                            <Input
                                            placeholder='Co-pay Amount'
                                            style={{ width: '140px', fontSize:'16px', marginLeft: '268px'}}
                                            value={coPayAmount}
                                            onChange={this.handleCoPayAmountChange}
                                            />
                                        ): (
                                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'152px'}}>{coPayAmount}</span></h8>
                                        )} */}
                                            {this.state.showInput ? (
                                                <Input
                                                    placeholder='Co-pay Amount'
                                                    style={{ width: '140px', fontSize: '16px', marginLeft: '268px' }}
                                                    value={coPayAmount}
                                                    onChange={this.handleCoPayAmountChange}
                                                    onBlur={this.handleCoPayAmountBlur}
                                                />
                                            ) : (
                                                <h8 style={{ color: '#b37f40', fontSize: '16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft: '126px' }}>
                                                    <span style={{ color: '#455a64', fontSize: '16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft: '152px' }}>
                                                        {coPayAmount}
                                                    </span>
                                                </h8>
                                            )}
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Difference Amount/NME's:</h8>
                            {this.state.showInput ? (
                            <Input
                                                    placeholder='Difference Amount'
                                                    style={{ width: '140px', fontSize:'16px', marginLeft: '196px'}}
                                                    value={differenceAmount}
                                                    onChange={this.handleDifferenceAmountChange}
                                                    onBlur={this.handleDifferenceAmountBlur}
                                                />
                                            ): (
                                                <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'80px'}}>{differenceAmount}</span></h8>
                                            )}
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Payable after insurance approval:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'142px'}}>{isNaN(parseFloat(totalBillAmount)) || isNaN(parseFloat(insuranceApproveAmount))
                                                ? 0
                                                : parseFloat(totalBillAmount) - parseFloat(insuranceApproveAmount)}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Discount if any:</h8>
                            {this.state.showInput ? (
                                                <Input
                                                    placeholder='Discount Amount'
                                                    style={{ width: '140px', fontSize:'16px', marginLeft: '280px'}}
                                                    value={discountAmount}
                                                    onChange={this.handleDiscountAmountChange}
                                                    onBlur={this.handleDiscountAmountBlur}
                                                />
                                            ): (
                                                <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'165px'}}>{discountAmount}</span></h8>
                                            )}                   
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Net Payable:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'250px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'64px'}}>{!isNaN(payableAmount) &&parseFloat ? Math.abs(payableAmount) : 0}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Less Advance:</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'174px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}>{lessAdvance || 0}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>{(payableAmount - lessAdvance) < 0 ? "Refund" : "To Collect"}</h8>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'270px'}}><span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:(payableAmount - lessAdvance) < 0 ? '86px' : '64px'}}>{!isNaN(payableAmount) && !isNaN(lessAdvance) ? Math.abs(payableAmount - lessAdvance) : 0}</span></h8>
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0">
                            {this.state.showInput ? (
                            <textarea placeholder="Remarks" autoFocus='true' className="textarea" style={{ height: '90px', width:'83%', marginLeft:'7%', marginTop:'1%'}} 
                                                                        value={insuranceCleranceRemarks ? insuranceCleranceRemarks  : ''} 
                                                                        onChange={(event) => this.handleInsuranceClearanceInputChange(event)}>
                            </textarea>
                            ):(
                                <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'50px'}}>Remarks: <span style={{color: '#455a64', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'330px'}}>{insuranceCleranceRemarks}</span></h8>
                            )
                        }
                            </div>
                        </div>
                        <div className="row w-100 mx-auto mt-3">
                            <div class="col-12 p-0" style={{marginTop:'30px'}}>
                            <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>(Authorized Signature)</h8>
                            </div>
                        </div>
                        <div style={{marginTop: '30px'}}>
                        <h8 style={{color: '#455a64', fontSize:'16px', fontWeight: 'bold', textTransform: 'capitalize',marginLeft:'48px', textDecoration: 'underline'}}>Details for NEFT/RTGS Refund</h8>
                        </div>
                        <table style={{ marginTop: '20px', marginLeft: '50px', borderCollapse: 'collapse', border: '1px solid black' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Name of the A/c holder</td>
                                                    <td style={{ border: '1px solid black', padding: '8px', width: '356px'}}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Name of the Bank</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Name of the branch</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>A/c Number</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>IFSC Code</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Relation with patient</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}>Contact Number</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}></td>
                                                </tr>

                                            </tbody>
                                        </table>
                            <div className="row w-100 mx-auto mt-3">
                                <div class="col-12 p-0" style={{marginTop: '50px'}}>
                                <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize',marginLeft:'48px'}}>Signature of the patient / Attendant</h8>
                                <h8 style={{color: '#b37f40', fontSize:'16px', fontWeight: 'normal', textTransform: 'capitalize', marginLeft:'126px'}}>Audit Signature</h8>
                            </div>
                        </div>
                        {/* <div style={{marginTop: '60px', marginLeft: '270px'}}>
                            <button className="btn btn-success" onClick={() => { this.submitConsent() }}>Submit</button>
                        </div> */}
                    </React.Fragment>
                    <div class="row pt-3">
                        
                    </div>
                    </div>
                    <div style={{marginTop: '60px', marginLeft: '270px'}}>
                            <button className="btn btn-success" onClick={() => { this.submitConsent() }}>Submit</button>
                        </div>
                </Modal>
                )}
            </div>
        )
    }
}

export default PostAuthWorklist_completed;